import { CircularProgress } from '@mui/material';
import type { ComponentProps } from 'react';

import { ImageOverlay } from '../ImageOverlay/ImageOverlay';
import { ProgressiveImage } from '../ProgressiveImage/ProgressiveImage';
import { ResultIcon, type ResultIconProps } from '../ResultIcon/ResultIcon';

type Props = ComponentProps<typeof ProgressiveImage> & {
  isLoading?: boolean;
  uploadProgress?: number;
  slotProps?: {
    resultIcon?: ResultIconProps;
  };
};

export const EvidenceImage = (props: Props) => {
  const { isLoading, uploadProgress, slotProps, ...rest } = props;

  return (
    <>
      {isLoading && uploadProgress ? (
        <ImageOverlay
          sx={{
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <CircularProgress
            sx={{
              color: 'white',
            }}
            variant="determinate"
            value={uploadProgress}
          />
        </ImageOverlay>
      ) : null}
      {!isLoading && slotProps?.resultIcon && slotProps.resultIcon.variant ? (
        <ImageOverlay
          sx={{
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <ResultIcon {...slotProps?.resultIcon} />
        </ImageOverlay>
      ) : null}
      <ProgressiveImage
        sx={{
          aspectRatio: '1 / 1',
          display: 'block',
          height: 'auto',
        }}
        rounded
        data-testid="evidence-image"
        alt="photo evidence"
        zoomOnHover={true}
        {...rest}
      />
    </>
  );
};
